import { useEffect, useMemo, useSyncExternalStore } from "react";
import type { MintHistoryContext } from "../api/mint-history";
import { MintHistoryController, type MintHistoryState } from "./mint-history-controller";

const unavailable: MintHistoryState = { page: null, pending: null, error: null, notice: null };
const noopSubscribe = () => () => {};
const getUnavailable = () => unavailable;

export function useMintHistory(context: MintHistoryContext | null) {
  const api = context?.api, chainId = context?.chainId, collectionAddress = context?.collectionAddress.toLowerCase(), environment = context?.environment;
  const controller = useMemo(() => api && chainId && collectionAddress && environment ?
    new MintHistoryController({ api, chainId, collectionAddress, environment }) : null,
  [api, chainId, collectionAddress, environment]);
  const state = useSyncExternalStore(controller?.subscribe ?? noopSubscribe, controller?.getSnapshot ?? getUnavailable);
  useEffect(() => { controller?.start(); return () => controller?.stop(); }, [controller]);
  return { ...state, refresh: controller?.refresh, loadMore: controller?.loadMore };
}
